import React, {Fragment, useEffect, useState} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {dateFilter, optionFilter} from "../../../utils/filters";
import {DateTimeFormatter, PidFormatter, remoteOptionFormatter, UnitFormatter} from "../../../utils/formatters";
import {Tooltip} from "react-tippy";
import CheckBox from "../../form/CheckBox";
import Select from "../../form/Select";
import { saveComponent } from 'src/utils/components';

function ClientSettled ({
    value,
    id,
    idfield,
}) {
    const [v, sv] = useState(value);
    useEffect(() => {
        sv(value);
    }, [value]);
    return (
        <CheckBox
            label={false}
            value={v}
            saveChanges={async (_, v, e) => {
                e.preventDefault();
                e.stopPropagation();
                //console.log(v);
                const data = {
                    [idfield]: id,
                    client_settled: v
                };
                //console.log(data);
                await saveComponent("BooklogStoreOrder", data);
                sv(v);
            }}
        />
    )
}

class StoreorderList extends React.Component {

    state = {
        send: false
    };

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = this.props.parent === undefined;
        const sortable = true;
        const {view, componentConfig, listFilter, selection, isLoading} = this.props;
        const props = {componentConfig, filter: listFilter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        const bulkComplete = this.props.bulkComplete || [];
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : (filterable ? "BooklogStoreOrderList" : "BooklogStoreOrderListSubList")}
                {...props}
                namedFilters={filterable}
                className="p-small-table"
                searchfield={filterable}
                visibleColumns={[
                    "orderdate",
                    "pid",
                    "orderid",
                    "booklog_id",
                    ...(this.props.out ? ["shippingmethod",
                        "notenum"] : []),
                    "itemcount",
                    "itemsum",
                    "partner.name",
                    "location_name",
                    "partner_id",
                    "state",
                    "client_settled",
                    "actions",
                ]}
                columnSort={[
                    "orderdate",
                    "pid",
                    "orderid",
                    "booklog_id",
                    ...(this.props.out ? ["shippingmethod",
                        "notenum"] : []),
                    "itemcount",
                    "itemsum",
                    "partner.name",
                    "location_name",
                    "partner_id",
                    "state",
                    "client_settled",
                    "actions",
                ]}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        sortable,
                        filterable
                    },
                    "pid": {
                        header: 'Azonosító',
                        sortable,
                        filterable,
                        renderer: PidFormatter,
                    },
                    "orderdate": {
                        header: 'Rendelés dátuma',
                        width: 1,
                        sortable,
                        filterable: dateFilter(),
                        className: "nowrap"
                    },
                    "orderid": {
                        header: 'Partner rendelés azonosító',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "booklog_id": {
                        header: 'Booklog azonosító',
                        width: 1,
                        sortable,
                        filterable
                    },
                    ...(this.props.out ? {
                        "shippingmethod": {
                            header: 'Szállítási mód',
                            width: 1,
                            sortable,
                            filterable
                        },
                        "notenum": {
                            header: 'Szállításilevél szám',
                            width: 1,
                            sortable,
                            filterable
                        }
                    } : {}),
                    "itemcount": {
                        header: 'Tételszám',
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, row.unit),
                        className: "unit"
                    },
                    "itemsum": {
                        header: 'Darabszám',
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, row.unit),
                        className: "unit"
                    },
                    "partner.name": {
                        header: 'Partner',
                        sortable,
                        filterable
                    },
                    "location_name": {
                        header: 'Szállító',
                        sortable,
                        filterable
                    },
                    "partner_id": {
                        header: 'Azonosító',
                        sortable,
                        filterable
                    },
                    "state": {
                        header: 'Státusz',
                        width: 1,
                        sortable,
                        operator: "=",
                        filterable: optionFilter(this.props.config?.fielddefs?.state?.optionname ?? "BooklogStoreOrder_state"),
                        renderer: remoteOptionFormatter(this.props.config?.fielddefs?.state?.optionname ?? "BooklogStoreOrder_state"),
                        className: "nowrap"
                    },
                    ...(this.props.claim ? {
                        "claim_date": {
                            header: 'Reklamáció dátuma',
                            width: 1,
                            sortable,
                            filterable: dateFilter(),
                            renderer: DateTimeFormatter
                        },
                        "ordertype": {
                            header: 'Típus',
                            width: 1,
                            sortable,
                            operator: "=",
                            filterable: <Select
                                storeType="local"
                                options={[
                                    {key: "0", label: "Kiszedés"},
                                    {key: "1", label: "Bevételezés"}
                                ]}
                                label={false}
                                objectValue={false}
                                isClearable={true}
                                valueKey="key"
                                labelKey="label"
                            />,
                            renderer: (value) => ({"0": "Kiszedés","1": "Bevételezés"})[value]
                        },
                    } : {}),
                    "client_settled": {
                        header: 'Feldolgozva',
                        renderer: (value, rowData) => {
                            return <ClientSettled
                                idfield={componentConfig.idfield}
                                id={rowData[componentConfig.idfield]}
                                value={value}
                            />;
                        }
                    },
                    ...(this.props.user.hasPermission("all_storeorders") && this.props.parent === undefined ? {
                        "actions": {
                            header: ' ',
                            renderer: (value, rowData) => {
                                if (this.props.stateType.Completed(rowData.state)) {
                                    const id = rowData[this.props.componentConfig.idfield];
                                    const checked = bulkComplete.indexOf(id);
                                    return <CheckBox
                                        checked={checked !== -1}
                                        label={false}
                                        saveChanges={(f, v, e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (checked !== -1) {
                                                bulkComplete.splice(checked, 1);
                                            } else {
                                                bulkComplete.push(id);
                                            }
                                            this.props.setBulkComplete(bulkComplete);
                                        }}
                                    />;
                                }
                            }
                        }
                    } : {}),
                }}
                rowClassName={(rowData) => {
                    if (this.props.stateType.RevisionNotification(rowData.state) || this.props.stateType.RevisionProcessed(rowData.state) || this.props.stateType.Revision(rowData.state) || this.props.stateType.Processed(rowData.state) || this.props.stateType.Modification(rowData.state)) {
                        return {"danger": true};
                    } else if (this.props.stateType.Completed(rowData.state)) {
                        return {"success": true};
                    } else if (this.props.stateType.Revision(rowData.state, "<")) {
                        return {"warning": true};
                    } else if (this.props.stateType.Completed(rowData.state, ">")) {
                        return {"deleted": true};
                    }
                }}
                orderBy={{field: "orderdate", direction: "DESC"}}
                sortBy={[{field: componentConfig.idfield, direction: "DESC"}]}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
                paginatorRight={this.props.user.hasPermission("all_storeorders") ? (props) => <Fragment>
                    <Tooltip title={this.props.all ? "Csak a partner rendeléseit mutassa" : "Mindent mutat"}>
                        <CheckBox
                            onIcon={{lib: "fa", name: "box"}}
                            offIcon={{lib: "fa", name: "box-open"}}
                            value={!this.props.all}
                            label={false}
                            saveChanges={() => {
                                this.props.setAll(!this.props.all);
                            }}
                            {...props}
                        />
                    </Tooltip>
                </Fragment>: null}
            />
        );
    }
}

export default StoreorderList;
